<template>
	<c-dialog ref="dialog" title="生产入库检详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.quality_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.quality_code}}</label>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="质检人">
						{{detailData.test_user_realname}}
					</c-detail-item>
					<c-detail-item label="质检时间">
						{{detailData.test_date}}
					</c-detail-item>
					<c-detail-item label="质检数">
						{{detailData.test_count}}
					</c-detail-item>
					<c-detail-item label="检验合格数">
						{{detailData.test_fine_count}}
					</c-detail-item>
					<c-detail-item label="检验不合格数">
						{{detailData.test_defects_count}}
					</c-detail-item>
					<c-detail-item label="检验合格率">
						{{parseFloat((detailData.test_fine_count*100/detailData.test_count).toFixed(2))}}%
					</c-detail-item>
					<c-detail-item label="审批状态">
						<c-state dict="auditState2Dic" :value="detailData.approve_state"></c-state>
					</c-detail-item>
					<c-detail-item label="备注">
						{{detailData.remark||'-'}}
					</c-detail-item>
					<c-detail-item label="批次备注" v-if="detailData.fine_auto_in == 1 && systemConfig.batch_stock == 1">
						{{detailData.batch_remark||'-'}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item label="审批人">
						{{detailData.approve_user_realname||'-'}}
					</c-detail-item>
					<c-detail-item label="审批时间">
						{{detailData.approve_date||'-'}}
					</c-detail-item>
					<custom-detail work-type="44" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="检验列表" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="detailTable" view-id="20022" height="grow" readonly>
							<!--质检良品率-->
							<template #test_fine_ratio="{data}">
								{{parseFloat((data.test_fine_count*100/data.test_count).toFixed(6))}}%
							</template>
						</custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		name: 'qualityWorkDetail',

		computed: {
			...mapState(['systemConfig'])
		},

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/quality/work/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.detailTable.init();
						this.$refs.detailTable.$refs.list.setData(data.detailList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>